class RegisterEmailController {
    /*@ngInject*/
    constructor() {
        this.requestPending = false;
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }
}

export default RegisterEmailController;
